module.exports = __webpack_public_path__ + "static/7-f6ae480a45601c372613dd4e1e5b012d.jpg";